module.exports = __webpack_public_path__ + "img/nv.06b5d8f2.png";